import { useState } from "react";
import { Menu, X, Instagram } from "lucide-react";
import { navLinks, whatsappUrl, instagramUrl } from "../../config/siteConfig";
import { WhatsAppIcon } from "./icons";

export const Navbar = () => {
    const [open, setOpen] = useState(false);

    return (
        <nav
            data-testid="main-nav"
            className="sticky top-0 z-50 bg-[#0a0c10]/90 backdrop-blur-md border-b border-[#1e2430]"
        >
            <div className="max-w-6xl mx-auto px-6 h-16 flex items-center justify-between">
                <a href="#inicio" className="flex items-center gap-3" data-testid="nav-logo">
                    <img
                        src="/images/logo-mark.png"
                        alt="Linkora"
                        className="h-9 w-9 object-contain"
                    />
                    <span className="font-bold tracking-tight text-white text-lg">linkora</span>
                    <span className="code-font text-[10px] text-blue-400 bg-blue-950/60 px-2 py-0.5 rounded border border-blue-800/40">
                        studio
                    </span>
                </a>

                <div className="hidden md:flex items-center gap-8 text-sm text-slate-300">
                    {navLinks.map((link) => (
                        <a
                            key={link.id}
                            href={`#${link.id}`}
                            data-testid={`nav-link-${link.id}`}
                            className="hover:text-white transition-colors"
                        >
                            {link.label}
                        </a>
                    ))}
                </div>

                <div className="flex items-center gap-3">
                    <div className="hidden md:flex items-center gap-2">
                        {whatsappUrl && (
                            <a
                                href={whatsappUrl}
                                target="_blank"
                                rel="noopener noreferrer"
                                aria-label="Falar pelo WhatsApp"
                                data-testid="nav-whatsapp"
                                className="p-2 rounded-md border border-[#263142] text-slate-300 hover:text-white hover:border-[#2563eb]/60 transition-colors"
                            >
                                <WhatsAppIcon className="w-4 h-4" />
                            </a>
                        )}
                        {instagramUrl && (
                            <a
                                href={instagramUrl}
                                target="_blank"
                                rel="noopener noreferrer"
                                aria-label="Instagram da Linkora"
                                data-testid="nav-instagram"
                                className="p-2 rounded-md border border-[#263142] text-slate-300 hover:text-white hover:border-[#2563eb]/60 transition-colors"
                            >
                                <Instagram className="w-4 h-4" />
                            </a>
                        )}
                    </div>
                    <a
                        href="#orcamento"
                        data-testid="nav-cta-orcamento"
                        className="hidden sm:inline-block px-4 py-2 bg-[#2563eb] hover:bg-[#1d4ed8] text-white text-xs font-semibold rounded-md uppercase tracking-wider transition-colors shadow-lg shadow-blue-600/20"
                    >
                        Solicitar orçamento
                    </a>
                    <button
                        type="button"
                        aria-label={open ? "Fechar menu" : "Abrir menu"}
                        aria-expanded={open}
                        data-testid="mobile-menu-button"
                        onClick={() => setOpen((v) => !v)}
                        className="md:hidden p-2 rounded-md border border-[#263142] text-slate-200 hover:bg-[#131822] transition-colors"
                    >
                        {open ? <X className="w-5 h-5" /> : <Menu className="w-5 h-5" />}
                    </button>
                </div>
            </div>

            {open && (
                <div
                    data-testid="mobile-menu"
                    className="md:hidden border-t border-[#1e2430] bg-[#0a0c10] px-6 py-4 flex flex-col gap-1"
                >
                    {navLinks.map((link) => (
                        <a
                            key={link.id}
                            href={`#${link.id}`}
                            data-testid={`mobile-nav-link-${link.id}`}
                            onClick={() => setOpen(false)}
                            className="py-2.5 text-sm text-slate-300 hover:text-white transition-colors"
                        >
                            {link.label}
                        </a>
                    ))}
                    <a
                        href="#orcamento"
                        data-testid="mobile-cta-orcamento"
                        onClick={() => setOpen(false)}
                        className="mt-2 px-4 py-3 bg-[#2563eb] hover:bg-[#1d4ed8] text-white text-xs font-semibold rounded-md uppercase tracking-wider text-center transition-colors"
                    >
                        Solicitar orçamento
                    </a>
                    <div className="flex gap-3 mt-3">
                        {whatsappUrl && (
                            <a
                                href={whatsappUrl}
                                target="_blank"
                                rel="noopener noreferrer"
                                data-testid="mobile-whatsapp"
                                onClick={() => setOpen(false)}
                                className="flex-1 px-4 py-3 border border-[#263142] text-slate-200 text-xs font-semibold rounded-md flex items-center justify-center gap-2 hover:border-[#2563eb]/60 transition-colors"
                            >
                                <WhatsAppIcon className="w-4 h-4" />
                                Falar pelo WhatsApp
                            </a>
                        )}
                        {instagramUrl && (
                            <a
                                href={instagramUrl}
                                target="_blank"
                                rel="noopener noreferrer"
                                data-testid="mobile-instagram"
                                onClick={() => setOpen(false)}
                                className="flex-1 px-4 py-3 border border-[#263142] text-slate-200 text-xs font-semibold rounded-md flex items-center justify-center gap-2 hover:border-[#2563eb]/60 transition-colors"
                            >
                                <Instagram className="w-4 h-4" />
                                Instagram
                            </a>
                        )}
                    </div>
                </div>
            )}
        </nav>
    );
};
